import { FirebaseData } from "../General/FirebaseData";
import { SurveyData } from "./SurveyData";
import { UnitData } from "../Property/Units/UnitData";
import { UserData } from "../User/UserData";
import { LocalData } from "../General/LocalData";
import { Timestamp } from "firebase/firestore";

export class SurveyAnswerData extends FirebaseData {
  report: SurveyData;
  unit: UnitData;

  user?: UserData;
  answers: { [key: string]: any }[] = [];
  answerDate?: Date;

  constructor(id: string, report: SurveyData) {
    super(id, "answers", report);
    this.report = report;
    this.unit = LocalData.getUnitWithId(id);
  }

  setup(data: { [key: string]: any }) {
    if (super.isValidString(data.userID)) {
      this.user = LocalData.users.addData(data.userID);
    }
    if (data.answerDate as Timestamp) {
      this.answerDate = (data.answerDate as Timestamp).toDate();
    }
    if (this.isValidDate(data.answerDate)) {
      this.answerDate = data.answerDate;
    }
    if (Array.isArray(data.answers)) {
      this.answers = data.answers;
    }
    super.setup(data);
  }

  isReportedByUserUnit(): boolean {
    for (let member of LocalData.currentUser.memberDatas) {
      for (let unit of member.units) {
        if (unit === this.unit) {
          return true;
        }
      }
    }
    return false;
  }
}
